// extracted by mini-css-extract-plugin
export default {"history":"styles_history__D9j-L","cards":"styles_cards__pvBRt","containerLeave":"styles_containerLeave__OCX-V"};